import SsvOrderWrap from './OrderWrap';
import ThankContainer from './ThankContainer';
import SsvOrderRouter from './SsvOrderRouter';

export default {
    path: '/skola-suche-vystavby/',
    component: SsvOrderRouter,
    children: [
        {
            path: 'objednavka/dekujeme',
            name: 'ssv.order.thank',
            component: ThankContainer,
            meta: {title: 'Děkujeme za objednávku'},
        },
        {
            path: 'objednavka/:courseDateId',
            name: 'ssv.order',
            component: SsvOrderWrap,
            meta: {title: 'Přihláška na školení'},
        },
        {
            path: 'darkovy-poukaz/:courseSlug',
            name: 'ssv.order.gift',
            component: SsvOrderWrap,
            meta: {title: 'Objednávka dárkového poukazu'},
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/ssv-order/router.js